// @docs:
//   - docs/wip/CREW_PAPER_REQUESTS.md  § Passport reads itself (Phase 4)
// ==============================================
// Passport details as the crew flow keeps them (the contract's suggested keys).
// Phase 4 reads them from the photo's machine-readable zone on the phone —
// passportReaderUi.tsx (the item screen's hook) → passportReaderClient.ts →
// passportReader.worker.ts (passportLocate, passportOcrEngine, passportMrz) —
// and prefills these fields for the person to check before Save.
// ==============================================

export interface PassportDetails {
  surname: string;
  given_names: string;
  nationality: string;
  number: string;
  date_of_birth: string;
  /** also sent as the paper's expires_on, which drives expiry reminders */
  expiry: string;
}

export const EMPTY_PASSPORT: PassportDetails = { surname: '', given_names: '', nationality: '', number: '', date_of_birth: '', expiry: '' };

export function passportFromDetails(d: Record<string, string | null> | null | undefined, expiresOn?: string | null): PassportDetails {
  const v = (k: keyof PassportDetails) => (d?.[k] ?? '') || '';
  return { surname: v('surname'), given_names: v('given_names'), nationality: v('nationality').toUpperCase(), number: v('number'), date_of_birth: v('date_of_birth'), expiry: v('expiry') || expiresOn || '' };
}

/** The details sent with the upload: trimmed, blanks as null, nationality as its code in capitals. */
export function passportPayload(p: PassportDetails): Record<string, string | null> {
  const t = (s: string) => s.trim() || null;
  return {
    surname: t(p.surname), given_names: t(p.given_names), nationality: t(p.nationality.toUpperCase()),
    number: t(p.number.replace(/\s+/g, '')), date_of_birth: t(p.date_of_birth), expiry: t(p.expiry),
  };
}
